import React from 'react';
import PropTypes from 'prop-types';
import { promoComponentPropTypes } from '../../utilities/commonPropTypes';
import { buildSrOnlyText } from '../../utilities/srOnly';

const PromoSrOnly = ({ promo }) => {
	const text = buildSrOnlyText(promo);
	if (!text) return null;
	return (
		<div id={`sr-only-${promo.id}`} className="sr-only">
			{text}
		</div>
	);
};

PromoSrOnly.propTypes = {
	promo: PropTypes.shape(promoComponentPropTypes).isRequired
};

export default PromoSrOnly;
